var React = require('react');

function Cz (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#eee","d":"M0 0h512v256l-265 45.2z","key":0}),React.createElement("path",{"fill":"#d80027","d":"M210 256h302v256H0z","key":1}),React.createElement("path",{"fill":"#0052b4","d":"M0 0v512l256-256L0 0z","key":2})])]);
}

Cz.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Cz;

Cz.default = Cz;
